import { filterDigits } from 'shared/utils/string/string.helpers';

const CARD_NUMBER_REGEX = /(\d{4})(?=\d)/g;
export const CARD_DIGITS_ONLY_REGEX = /^\d+$/;

export const formatCardNumber = (text: string): string =>
  filterDigits(text).replace(CARD_NUMBER_REGEX, '$1 ').slice(0, 19);

export const isValidCardNumber = (digits: string): boolean =>
  CARD_DIGITS_ONLY_REGEX.test(digits) &&
  digits.length === 16 &&
  validateLuhn(digits);

export const validateLuhn = (value: string): boolean => {
  const sanitized = value.replace(/\s/g, '');

  if (!CARD_DIGITS_ONLY_REGEX.test(sanitized)) {
    return false;
  }

  let sum = 0;
  let shouldDouble = false;

  for (let i = sanitized.length - 1; i >= 0; i--) {
    let digit = parseInt(sanitized.charAt(i), 10);

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
};
